const middleware = {}

middleware['accept-terms-condition'] = require('../../../middleware/accept-terms-condition.js')
middleware['accept-terms-condition'] = middleware['accept-terms-condition'].default || middleware['accept-terms-condition']

middleware['check-param'] = require('../../../middleware/check-param.js')
middleware['check-param'] = middleware['check-param'].default || middleware['check-param']

middleware['find-company-auth'] = require('../../../middleware/find-company-auth.js')
middleware['find-company-auth'] = middleware['find-company-auth'].default || middleware['find-company-auth']

middleware['find-company-guest'] = require('../../../middleware/find-company-guest.js')
middleware['find-company-guest'] = middleware['find-company-guest'].default || middleware['find-company-guest']

middleware['maintenance-mode'] = require('../../../middleware/maintenance-mode.js')
middleware['maintenance-mode'] = middleware['maintenance-mode'].default || middleware['maintenance-mode']

middleware['portal-auth'] = require('../../../middleware/portal-auth.js')
middleware['portal-auth'] = middleware['portal-auth'].default || middleware['portal-auth']

middleware['portal-guest'] = require('../../../middleware/portal-guest.js')
middleware['portal-guest'] = middleware['portal-guest'].default || middleware['portal-guest']

middleware['role-match'] = require('../../../middleware/role-match.js')
middleware['role-match'] = middleware['role-match'].default || middleware['role-match']

middleware['statement-declaration'] = require('../../../middleware/statement-declaration.js')
middleware['statement-declaration'] = middleware['statement-declaration'].default || middleware['statement-declaration']

export default middleware
